<template>
    <div class="wrap">
        <div class="topimg">
            <img src="../../assets/img/TalentCenter.png" />
        </div>
        <div class="filter">
<!--            <el-select style="width: 180px;margin:10px 28px 10px 0px;" v-model="sourcevalue" multiple collapse-tags-->
<!--                       placeholder="简历来源">-->
<!--                <el-option v-for="item in sourceList" :key="item.value" :label="item.label" :value="item.id">-->
<!--                </el-option>-->
<!--            </el-select>-->

            <el-select style="width: 120px;margin: 10px 28px 10px 0px;" multiple collapse-tags :placeholder="Agese">
                <el-option style="height:80px;padding-right: 20px;" disabled>
                    <span>请输入年龄范围，不填写则为不限</span><br>
                    <div style="display: flex;justify-content: center;">
              <span>
                <el-input style="width: 80px;" v-model="startAge" @blur="inputblur"></el-input>
              </span>&nbsp; —— &nbsp;
                        <span>
                <el-input style="width: 80px;" v-model="endAge" @blur="inputblur"></el-input>
              </span>
                    </div>
                </el-option>
            </el-select>

            <el-select style="width: 120px;margin: 10px 28px 10px 0px;" multiple collapse-tags :placeholder="workse">
                <el-option style="height:80px;padding-right: 20px;" disabled>
                    <span>请输入工作年限范围，不填写则为不限</span><br>
                    <div style="display: flex;justify-content: center;">
              <span>
                <el-input style="width: 80px;" v-model="startWork" @blur="Workblur"></el-input>
              </span>&nbsp; —— &nbsp;
                        <span>
                <el-input style="width: 80px;" v-model="endWork" @blur="Workblur"></el-input>
              </span>
                    </div>
                </el-option>
            </el-select>

            <el-select style="width: 150px;margin: 10px 28px 10px 0px;" v-model="activeEducation" multiple collapse-tags
                       placeholder="学历">
                <el-option v-for="item in educationList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>

            <el-select style="width: 80px;margin: 10px 28px 10px 0px;" v-model="activeSex" placeholder="性别">
                <el-option v-for="(item, index) in sexList" :key="index" :label="item.label" :value="item.value">
                </el-option>
            </el-select>

            <el-select style="width: 240px;margin: 10px 28px 10px 0px;" v-model="activeSkill" multiple collapse-tags
                       placeholder="选择技能标签">
                <el-option v-for="item in skillList" :key="item.value" :label="item.skill" :value="item.id">
                </el-option>
            </el-select>

            <el-select style="width: 200px;margin: 10px 28px 10px 0px;" v-model="activeCertification" multiple collapse-tags
                       placeholder="人才认证">
                <el-option v-for="item in certificationList" :key="item.value" :label="item.label" :value="item.id">
                </el-option>
            </el-select>

            <button class="reset" @click="restComponent">重置</button>
            <button class="sizer" @click="onRefresh">筛选</button>
        </div>
        <div class="pagessc">
            <div class="wrap6s flex-col" v-for="(item, index) in datalist" :key="index" @click="godatas(item.id)">
                <div class="bd2s flex-col">
                    <div class="box6 flex-row">
                        <span class="word12">{{ item.userName }}</span>
                        <img class="img2" referrerpolicy="no-referrer" src="./assets/img/yihurencai.png"  v-show="item.talentCertSw" />
                    </div>
                    <div class="box7 flex-row">
                        <span class="info5">{{ item.age }}岁</span>
                        <span class="word13">{{ item.workYear }}年工作经验</span>
                        <span class="txt6">{{ item.eduName }}</span>
                        <span class="txt7">{{ item.schoolName }}</span>
                    </div>
                    <div class="box8 flex-col">
                        <div class="section3 flex-row">
                            <div class="skills-list">
                                <div :class="i.certStatus ? 'renzheng item' : 'item'" v-for="(i, j) in item.userSkill"
                                    :key="j">
                                    <img src="./assets/img/renzheng.png" alt="" v-show="i.certStatus" />
                                    {{ i.skill }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="nodata" v-if="datalist.length == 0">
                <img src="../Candidate/assets/img/NoData2.png">
                <p>暂无人才简历</p>
            </div>

            <el-pagination v-if="datalist.length !== 0" @current-change="handleCurrentChange" :current-page="page"
                layout="total, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import qs from 'qs';
export default {
    data() {
        return {
            resumeData: {}, //个人简历
            sourcevalue: [],//选中的简历来源
            sourceList: [
                {
                    label: "不限",
                    id: 'null',
                },
                {
                    label: "自投递",
                    id: "user",
                },
                {
                    label: "AI人才匹配",
                    id: "AI",
                },
                {
                    label: "人才库",
                    id: "active",
                },
            ],//简历来源列表
            skillList: [], //技能列表
            activeCertification: [], //多选认证数组
            startAge: null, //年龄范围
            endAge: null, //年龄范围
            Agese: '年龄', //年龄范围
            workse: '经验', //经验范围
            startWork: null, //工作年限范围
            endWork: null, //工作年限范围
            activeSex: null, //选中性别
            activeEducation: [], //选中学历
            activeSkill: [], //多选技能数组

            certificationList: [
                {
                    label: "壹护认证人才",
                    id: 1,
                },
                {
                    label: "技能官方认证",
                    id: 2,
                },
            ], //认证数组
            sexList: [
                {
                    label: "不限",
                    value: 0,
                },
                {
                    label: "男",
                    value: 1,
                },
                {
                    label: "女",
                    value: 2,
                },
            ], //性别数组
            educationList: [
                {
                    label: "高中",
                    value: 1,
                },
                {
                    label: "大专",
                    value: 2,
                },
                {
                    label: "本科",
                    value: 3,
                },
                {
                    label: "研究生",
                    value: 4,
                },
                {
                    label: "博士",
                    value: 5,
                },
            ], //学历数组
            activeTab: 0,
            total: 0,
            page: 1,
            pageSize: 10,
            datalist: [],//筛选后的数组

            parmes:{},
        }
    },
    methods: {
        godatas(resumeId) {
            const { href } = this.$router.resolve({
                path: '/TalentPoolils',
                query: {resumeId:resumeId,parmesdata:JSON.stringify(this.parmes)}
            });
            this.$store.state.stidx = 3;
            sessionStorage.setItem("store", this.$store.state.stidx);
            window.open(href, '_blank');
        },
        inputblur() {
            if (this.startAge != null && this.endAge != null) {
                this.Agese = this.startAge + '岁—' + this.endAge + '岁';
            }
        },
        Workblur() {
            if (this.startWork != null && this.endWork != null) {
                this.workse = this.startWork + '年 — ' + this.endWork + '年';
            }
        },
        tabfun(val) {
            this.activeTab = val;
            this.onRefresh();
        },
        // 重置筛选
        restComponent() {
            this.active = 0;
            this.activeSource = [];
            this.sourcevalue = [];
            this.startAge = null; //年龄范围
            this.endAge = null; //年龄范围
            this.Agese = "年龄"; //年龄范围
            this.startWork = null; //工作年限范围
            this.endWork = null; //工作年限范围
            this.workse = "经验"; //工作年限范围
            this.activeSex = null; //选中性别
            this.activeEducation = []; //选中学历
            this.activeSkill = []; //多选技能数组
            this.activeCertification = []; //多选认证数组
            this.onRefresh();
        },
        onRefresh() {
            let parmes = {
                companyId: localStorage.getItem("id"),
                sex: this.activeSex ? this.activeSex : 0,
                manageStatus: this.activeTab,
                page: this.page,
                pageSize: this.pageSize,
            };

            if (this.startAge !== null && this.endAge !== null) {
                parmes.startAge = this.startAge;
                parmes.endAge = this.endAge;
            }
            if (this.startWork !== null && this.endWork !== null) {
                parmes.workStart = this.startWork;
                parmes.workEnd = this.endWork;
            }
            if (this.activeEducation.length !== 0) {
                let arry = [];
                this.activeEducation.map((item) => {
                    arry.push(item);
                });
                parmes.edu = arry.join(",");
            }
            if (this.sourcevalue.length !== 0) {
                let arry = [];
                this.sourcevalue.map((item) => {
                    arry.push(item);
                });
                parmes.sourceType = arry.join(",");
            } else {
                parmes.sourceType = "";
            }

            if (this.activeCertification.length !== 0) {
                let arry = [];
                this.activeCertification.map((item) => {
                    arry.push(item);
                });
                parmes.personnel = arry.join(",");
            }
            if (this.activeSkill.length !== 0) {
                let arry = [];
                this.activeSkill.map((item) => {
                    arry.push(item);
                });
                parmes.skill = arry.join(",");
            }
            this.parmes = parmes;
            this.$apiFun.seekPersonnel(qs.stringify(parmes)).then((data) => {
                if (data.code === 200) {
                    this.datalist = data.data.list;
                    this.total = data.data.total;
                    this.page = data.data.page;
                    this.pageSize = data.data.pageSize;
                    this.loading.close();
                }
            })
        },
        //监听 页码值 改变的事件
        handleCurrentChange(newPage) {
            this.page = newPage;
            this.onRefresh();
            // this.page = newPage;//重新指定当前页
            // this.getUsersList();//带着新的分页请求获取数据
        }
    },
    mounted() {
        this.loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        this.onRefresh();
        this.$apiFun.skillAll().then((data) => {
            if (data.code === 200) {
                this.skillList = data.data;
            }
        })
    }
}
</script>
<style lang="less" scoped>
.wrap {
  height: 91vh;
  overflow: auto;
  border: none;
  border-bottom: none;
}
.topimg {
    img {
        width: calc(100% - 40px);
        height: auto;
        margin: 20px;
        object-fit: cover;

    }
}
.filter {
    width: calc(100% - 40px);
    margin: 0 20px;
    height: auto;
    background: #FFFFFF;
    border-radius: 4px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 20px 0 20px;
    flex-flow: wrap;

    .dropdown {
        border-radius: 4px;
        background-color: rgba(255, 255, 255, 1);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6C6E71;
        line-height: 50px;
        margin-right: 38px;
    }

    .reset {
        width: 60px;
        height: 30px;
        background: #FFC545;
        border-radius: 4px;
        color: rgba(255, 255, 255, 1);
        font-size: 12px;
        white-space: nowrap;
        line-height: 12px;
        margin-right: 20px;
    }

    .sizer {
        width: 60px;
        height: 30px;
        background: #3E7CFF;
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 12px;
    }
}

.page {
    width: calc(100% - 40px);
    margin: 20px;
    height: 80vh;
}

.pagessc {
    width: calc(100% - 40px);
    margin: 20px;

    .page1 {
        width: 100%;
        height: 156px;
        border-radius: 4px;
        background: #FFFFFF;
        padding: 24px 0 0 20px;

        .name {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                width: 94px;
                height: 21px;
                margin-right: 20px;
            }
        }

        .details {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6C6E71;
            line-height: 14px;

            span {
                margin-right: 45px;
            }
        }
    }
}
.wrap6s {
  height: 156px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  margin-bottom: 20px;

  .bd2s {
    width: 100%;
    height: 125px;
    margin: 19px 0 0 20px;

    .box6 {
      width: 100%;
      height: 21px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .word12 {
        width: auto;
        height: 16px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(0, 0, 0, 1);
        font-size: 16px;
        font-family: PingFangSC-Medium;
        white-space: nowrap;
        line-height: 16px;
        text-align: center;
        margin-top: 5px;
      }

      .img2 {
        width: 94px;
        height: 21px;
        margin-left: 18px;
      }
    }

    .box7 {
      width: 356px;
      height: 14px;
      margin-top: 20px;
      display: flex;
      justify-content: space-around;

      .info5 {
        width: 31px;
        height: 14px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(108, 110, 113, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 14px;
        text-align: center;
      }

      .word13 {
        width: 78px;
        height: 14px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(108, 110, 113, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 14px;
        text-align: center;
      }

      .txt6 {
        width: 28px;
        height: 14px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(108, 110, 113, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 14px;
        text-align: center;
      }

      .txt7 {
        width: 84px;
        height: 14px;
        display: block;
        overflow-wrap: break-word;
        color: rgba(108, 110, 113, 1);
        font-size: 14px;
        white-space: nowrap;
        line-height: 14px;
        text-align: center;
      }
    }

    .box8 {
      height: 46px;
      border-radius: 4px;
      background-color: rgba(247, 248, 251, 1);
      margin-top: 24px;
      width: calc(100% - 40px);
        .skills-list {
            display: flex;
            justify-content: flex-start;
            .item {
                height: 28px;
                background: #FFFFFF;
                border-radius: 4px;
                color: #2c86fd;
                font-size: 14px;
                text-align: center;
                font-family: PingFangSC-Regular;
                padding: 0 12px;
                margin-right: 26px;
                font-weight: bold;
                display: flex;
                align-items: center;
            }

            .renzheng {
                color: #3f93ff !important;
                background-color: #fff !important;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #6aabff;
                box-sizing: border-box;

                img {
                    width: 15px;
                    height: 16px;
                    margin-right: 10px;
                }
            }
        }
      .section3 {
        width: 346px;
        height: 28px;
        margin: 9px 0 0 12px;
      }
    }
  }
}
.nodata {
    text-align: center;
    margin: 15% auto;
}

.nodata img {
    width: 266px;
    height: 154px;
}

.nodata p {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 16px;
    text-align: center;
    padding-top: 14px;
}

.ah-pageing {
    text-align: left;
}
</style>